import * as m from "./../../dist/es2015/radar.js";
export const am5radar = m;